import React from 'react';
import { Grid } from '@mui/material';
import { EmailOutlined } from '@mui/icons-material';

import CardSwitch from '@/operator/components/general/cards/CardSwitch';
import { Invitation } from '@/operator/graphql/types/Invitation';

export interface UploadedInvitationListProps {
    invitationList: Invitation[];
    setInvitationList: React.Dispatch<React.SetStateAction<Invitation[]>>;
}

const UploadedInvitationList: React.FC<UploadedInvitationListProps> = ({
    invitationList,
    setInvitationList,
}) => {
    const changeRole = (index: number, newRoleValue: boolean) => {
        const tempList: Invitation[] = invitationList;
        tempList[index] = {
            ...invitationList[index],
            isAdmin: newRoleValue,
        };

        setInvitationList(tempList);
    };

    return (
        <Grid
            sx={{
                overflow: 'scroll',
                width: '100%',
                maxHeight: '200px',
            }}
        >
            {invitationList.map((invitation, index) => (
                <CardSwitch
                    key={invitation.email}
                    Icon={EmailOutlined}
                    description={invitation.email}
                    switchLabel="
              Make Admin?
            "
                    renderSwitch={true}
                    onChange={(newState) => changeRole(index, newState)}
                />
            ))}
        </Grid>
    );
};

export default UploadedInvitationList;
